"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ColorPicker = _interopRequireDefault(require("./ColorPicker"));

var _hooks = require("../../util/hooks");

require("./ColorPickerPopover.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ColorPickerPopover = function ColorPickerPopover(_ref) {
  var color = _ref.color,
      _ref$color$rgb = _ref.color.rgb,
      rgb = _ref$color$rgb === void 0 ? {} : _ref$color$rgb,
      onChange = _ref.onChange,
      label = _ref.label,
      required = _ref.required;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var wrapperRef = (0, _react.useRef)(null);
  (0, _hooks.useOutsideClick)(wrapperRef, function () {
    return setOpen(false);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-color-picker-popover",
    ref: wrapperRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cp-container",
    onClick: function onClick() {
      return setOpen(function (o) {
        return !o;
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-cp-toggle' + (isOpen ? ' open' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-color-swatch",
    style: {
      background: "rgb(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ")")
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + (isOpen ? 'chevron-up' : 'chevron')
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-cp-label"
  }, label, required && /*#__PURE__*/_react["default"].createElement("span", {
    className: "required"
  }, "*"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-fader' + (isOpen ? ' show' : '')
  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker["default"], {
    color: color,
    onChange: onChange
  })));
};

ColorPickerPopover.propTypes = {
  color: _propTypes["default"].object.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string,
  required: _propTypes["default"].bool
};
var _default = ColorPickerPopover;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/ColorPicker/ColorPickerPopover.js
// module id = 1894
// module chunks = 0